import {
  Option,
  OptionStatus,
  Product,
  Subscription,
} from '@dch/products-business-logic';

export function buildTaggingProduct(
  product: Product,
  selectedItem?: Option | Subscription,
) {
  return JSON.stringify([
    {
      id: 'standAlone',
      products: [_buildBaseProduct(product, selectedItem)],
    },
  ]);
}

function _buildBaseProduct(
  product: Product,
  selectedItem?: Option | Subscription,
) {
  if (
    selectedItem &&
    selectedItem['optionCodeForDescription'] &&
    (selectedItem as Option).orderType === 'IFF'
  ) {
    return _buildItems(product, selectedItem);
  } else {
    return {
      id: product.groupMpcUuid,
      name: product.productDescription,
      action: 'existing',
      category: ProductLineClassification[product.plc],
      visible: true,
      points: 0,
      quantity: 1,
      products: _buildItems(product, selectedItem),
    };
  }
}

function _buildItems(product: Product, selectedItem?: Option | Subscription) {
  const items = [];
  if (product && selectedItem) {
    if (selectedItem['optionCodeForDescription']) {
      _getAllOptions(product)
        .filter(
          (option) =>
            !selectedItem ||
            (selectedItem as Option).optionCodeForDescription ===
              option.optionCodeForDescription,
        )
        .forEach((option) => {
          items.push({
            id: option.optionCodeForDescription,
            name: option.name,
            action:
              option.ibStatus === OptionStatus.ACTIVE ? 'existing' : 'new',
            category: ProductLineClassification[product.plc],
            visible: true,
            points: 0,
            quantity: 1,
            price: option.price?.calculatedPriceNoVat,
          });
        });
    } else if (selectedItem['mpcUuid']) {
      if (product.availableSubscriptions) {
        product.availableSubscriptions
          .filter(
            (subscription) =>
              (selectedItem as Subscription).mpcUuid === subscription.mpcUuid,
          )
          .forEach((subscription) => {
            items.push({
              id: subscription.mpcUuid,
              name: subscription.name,
              action: 'new',
              category: ProductLineClassification[product.plc],
              visible: true,
              points: 0,
              quantity: 1,
              price: subscription.price?.calculatedPriceNoVat,
            });
          });
      }
    }
  }
  return items;
}

function _getAllOptions(product: Product) {
  return (product.options || [])
    .concat(product.configurableOptions || [])
    .concat(product.settings || [])
    .concat(product.configurableSettings || []);
}

enum ProductLineClassification {
  AA = 'Activation_and_Administration',
  CCE = 'Call_Connect_Endpoints',
  CB = 'Carrier_Billing',
  CPS = 'Carrier_Pre_Selection',
  CUG = 'Closed_User_Group',
  CLD = 'Cloud',
  CTBT = 'Conversion_to_Best_technology',
  DC = 'Delivery_Carrier',
  DV = 'Device',
  DNS = 'Domain_Name',
  EP = 'E_Press',
  ES = 'Easy_Switch',
  EL = 'Elevator_Line',
  FM = 'Family',
  FI = 'Fixed_Internet',
  FT = 'Fixed_Voice',
  HC = 'Home_and_Care',
  HT = 'Home_Termination',
  HST = 'Hosting',
  IM = 'Installation_Method',
  INF = 'Infrastructure',
  JO = 'Joint_Offer',
  MJO = 'Mcs_Joint_Offer',
  MMI = 'Mcs_Mobile_Internet',
  MMV = 'Mcs_Mobile_Voice',
  MSP = 'Message_Service',
  MI = 'Mobile_Internet',
  MV = 'Mobile_Voice',
  '0365' = 'Office_365',
  pack = 'Pack',
  PP = 'Prepaving',
  PAO = 'Pricing_Advantage_Offer',
  PO = 'Promo',
  PA = 'Promo_Advantage',
  SEC = 'Security',
  TM = 'Time_and_Material',
  TV = 'TV',
  TVE = 'TV_Everywhere',
  VC = 'Voucher',
  WDB = 'Website_Design',
}
